import React from 'react'
import withFieldError from 'components/form/with-error'
import { Field, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

const selector = formValueSelector('widget')

export const ThresholdInput = ({ input, meta: { touched, error } }) => {
  return (
    <input
      {...input}
      type='number'
      className={'form-control ' + (error && touched && 'has-error')}
      min={0}
      max={100}
      step={10}
      style={{
        width: '80px'
      }}
    />
  )
}
ThresholdInput.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}
const ThresholdInputWithError = withFieldError(ThresholdInput)

const isValidThreshold = value => {
  const intValue = parseInt(value, 10)
  return intValue >= 0 && intValue <= 100
}

export const _ThresholdVisual = ({ threshold }) => {
  let edgeWidth = `${threshold}%`
  let unsureWidth = `${100 - parseInt(threshold, 10)}%`

  if (!isValidThreshold(threshold)) {
    edgeWidth = '0%'
    unsureWidth = '100%'
  }

  return (
    <div className='form-group row'>
      <div className='col-md-12'>
        <div className='threshold-block reject' style={{ width: edgeWidth }}>
          {parseInt(threshold, 10) > 5 && (
            <span className='threshold-text'>
              <span role='img' aria-label='thumbs down'>
                👎
              </span>
              {'<'} {edgeWidth}
            </span>
          )}
        </div>
        <div
          className='threshold-block'
          style={{ width: unsureWidth, backgroundColor: '#ccc' }}
        >
          {100 - parseInt(threshold, 10) > 10 && (
            <span className='threshold-text'>
              Unsure{' '}
              <span role='img' aria-label='person shrugging shoulders'>
                🤷
              </span>
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
_ThresholdVisual.propTypes = {
  threshold: PropTypes.string
}

export const ThresholdVisual = connect(
  // istanbul ignore next
  state => ({
    threshold: selector(state, 'threshold')
  })
)(_ThresholdVisual)

export const validateThreshold = value => {
  if (!isValidThreshold(value)) {
    return 'Threshold can be between 0 and 100'
  }
}

export const _ConfigureThreshold = ({ threshold }) => {
  return (
    <div>
      <div className='form-group row'>
        <label className='col-md-3 control-label'>Safety threshold (%)</label>
        <div className='col-md-1'>
          <Field
            id='brt-experience-moderation-threshold'
            name='threshold'
            component={ThresholdInputWithError}
            className='col-md-9 form-control'
            defaultValue={threshold}
            validate={validateThreshold}
          />
        </div>
        <div className='col-md-8'>
          <em>
            This setting only affects items with a negative sentiment. Anything
            with a neutral or positive sentiment will be approved.
          </em>
        </div>
      </div>
      {typeof threshold !== 'undefined' && (
        <div id='threshold-visual-container'>
          <ThresholdVisual />
        </div>
      )}
    </div>
  )
}

_ConfigureThreshold.propTypes = {
  threshold: PropTypes.string
}

export const ConfigureThreshold = connect(
  // istanbul ignore next
  state => ({
    threshold: selector(state, 'threshold')
  })
)(_ConfigureThreshold)



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-moderation/threshold.js